/**
 * stub to prevent prismjs api from being accessed
 */
export default function prismIncludeLanguages(): void { }
